import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Con React.lazy el CSS de cada pantalla se carga bajo demanda y quedaba después de los estilos
// compartidos. Se importan aquí (antes que el tema) para mantener el orden de cascada original.
import './css/estilos.css';
import './css/form.css';
import './css/table.css';
import './css/users.css';
import './css/usersModern.css';
import './css/cajasModern.css';
import './css/standardModern.css';
import './css/reportes-dashboard.css';
import './css/perfil.css';
import './css/perfilModern.css';
import './css/userRole.css';
import './css/pagosOtrosModern.css';
import './css/preEvaluacionModern.css';
import './css/movimientosCajaModern.css';
import './css/projectProgress.css';
import './css/newApi.css';
import './css/login.css';
import './css/homeModern.css';
import './css/menuModern.css';
import './css/backButton.css';
import './css/theme.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
